import { useSessionStorage } from 'react-use';

import { useResponseHandler } from '@hooks/useResponseHandler';
import { useSession } from '@hooks/useSession';

import { ImagingStudyRecord } from '@models/imaging-study';

import { useGetImagingStudyQuery } from 'generated/imaging-study.generated';

export const useGetImagingStudy = (params: {
  record_id?: string;
  patient_id?: string;
}) => {
  const [token] = useSessionStorage('share_token');
  const {
    state: { activeProfile, isAuthenticated },
  } = useSession();
  const { handleError } = useResponseHandler({ handlerType: 'snackbar' });

  const patient_id = params.patient_id ?? activeProfile?.patient_id ?? '';
  const response = useGetImagingStudyQuery({
    variables: { input: { record_id: params.record_id ?? '', patient_id } },
    skip: !patient_id || !params.record_id,
    fetchPolicy: 'no-cache',
    // Only add authorization header if resource is being shared (not authenticated)
    ...(!isAuthenticated && {
      context: {
        headers: {
          authorization: token,
        },
      },
    }),
  });
  const { data, error } = response;
  if (error) {
    handleError(error);
  }
  const record = data?.getImagingStudy;
  return { ...response, data: record ? new ImagingStudyRecord(record) : null };
};
